<template>
  <div>
    <item
      v-for="item in roots"
      :key="item.id"
      :item="item"
      :all="items"
      :value="value"
      :border-variant="borderVariant"
      @toggleChecked="toggleChecked"
    />
  </div>
</template>

<script>
import Item from './Item'

export default {
  name: 'Categories',
  components: {
    Item
  },
  props: {
    items: { type: Array, required: true },
    value: Array,
    borderVariant: String
  },
  computed: {
    roots () {
      return this.items.filter(i => i.parentIds.length === 1)
    }
  },
  methods: {
    toggleChecked (checked, id) {
      if (checked)
        this.$emit('input', this.value.concat([id]))
      else
        this.$emit('input', this.value.filter(o => o !== id))
    }
  }
}
</script>
